import http from "../../core/services/http.service";
import {AppSettings} from "@/shared/AppSettings";
import ExportsService from "@/core/services/exports.service";
import bucketHelperService from "@/core/services/bucketHelper.service";
import i18nHelper from "@/core/services/i18n.service";
import DepartmentService from "@/modules/setup/department/DepartmentService";

export default {
  getInventories(params = null) {
    return http.get('/api/v1/inventories/', {params});
  },
  getImages(uuid) {
    return http.get(`/api/v1/inventories/${uuid}/images/`);
  },
  getInventory(id, expand) {
    return http.get(`/api/v1/inventories/${id}/?expand=${expand}`);
  },
  createInventory(data, expand = '') {
    return http.post(`/api/v1/inventories/?expand=${expand}`, data);
  },
  async downloadBulkUploadTemplate() {
    let response = await ExportsService.generateToken();

    if (!response.success) {
      return false;
    }

    window.open(AppSettings.url() + `/api/v1/inventories/bulk-upload-template/?token=${response.body.token}`, '_blank')
  },
  updateInventory(id, data, expand) {
    return http.put(`/api/v1/inventories/${id}/?expand=${expand}`, data);
  },
  partialUpdateInventory(id, data, expand) {
    return http.patch(`/api/v1/inventories/partial/${id}/?expand=${expand}`, data);
  },
  getInfo(params) {
    return http.get('/api/v1/inventories/info/', {params});
  },
  getReservationInfo(params) {
    return http.get('/api/v1/inventories/reservations/info/', {params});
  },
  prepareCreatedAndChangedImagesJson(imagesData, onUploadProgress) {
    return http.post('/api/v1/inventories/images/', imagesData, {
      headers: {
        'Content-Type': 'application/json'
      },
      onUploadProgress: onUploadProgress
    });
  },
  createImages(data, onUploadProgress) {
    return http.post('/api/v1/inventories/images/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  removeImage(inventoryUuid, uuids) {
    // TODO may change from body params to header params. Should be discussed
    return http.delete(`/api/v1/inventories/${inventoryUuid}/images/`, {
      data: {
        uuids: uuids
      }
    });
  },
  removeInventory(uuid) {
    return http.delete(`/api/v1/inventories/${uuid}/`)
  },
  removeSourceInventory(params) {
    return http.delete(`/api/v1/inventories/delete-grouped-item-source/`, {
      data: params
    })
  },
  removeLot(uuid) {
    return http.delete(`/api/v1/inventories/${uuid}/remove-lot/`)
  },
  reserveLots(data) {
    return http.post('/api/v1/inventories/', data);
  },
  getViewUrlForQrCode(url) {
    return AppSettings.portalUrl() + url;
  },
  getViewUrlForQrCodeWithoutUuid() {
    return `${AppSettings.portalUrl()}/inventory/view/{{uuid}}/dashboard`;
  },
  uploadBulkTemplate(data, onUploadProgress) {
    return http.post('/api/v1/inventories/bulk-upload/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress
    });
  },
  getBlankQrCodePdfData(amount = {}) {
    return http.post('/api/v1/qr-code/generate-blank/', {
      data: {amount}
    });
  },
  assignQRToInventory(data) {
    return http.post('/api/v1/qr-code/assign/', {
      data: data
    });
  },
  checkVimVrmCode(data) {
    return http.post('/api/v1/inventories/car-info/', data);
  },
  batchRemoveItems(uuids) {
    return http.delete(`/api/v1/inventories/`, {
      data: {uuids}
    });
  },
  batchArchiveItems(params) {
    return http.post(`/api/v1/inventories/archive/`, params);
  },
  batchUnarchiveItems(params) {
    return http.post(`/api/v1/inventories/unarchive/`, params);
  },
  convertBase64ToBlob(base64) {
    return fetch(base64)
      .then(res => res.blob())
  },
  uploadBlobToBucket(url, blob, type) {
    return fetch(url, {
      method: 'PUT',
      body: blob,
      headers: {'Content-Type': blob.type || type},
    })
  },
  getPresignedUrlForFileUpload(extension = '') {
    return http.get('/api/v1/bucket/get-presigned-url-for-file-upload/', {
      params: {
        extension,
        object_type: "inventory"
      }
    });
  },
  bulkUploadImages(payload) {
    return http.post('/api/v1/bucket/bulk-upload-images/', payload, {
      headers: {
        'Content-Type': 'application/json'
      },
    });
  },
  convertEventTargetToBase64(eventTarget) {
    return new Promise((resolve) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        return resolve(e.target.result)
      };
      fileReader.readAsDataURL(eventTarget);
    });

  },
  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  },
  createRenameAndDeleteImages(inventoryUuid, images, url, progressEvent) {
    const jsonData = {'inventory_uuid': inventoryUuid}
    return bucketHelperService.createRenameAndDeleteImages(images, url, "inventory", jsonData, progressEvent)
  },
  syncInventoryItemsWithThirdParty() {
    return http.post('/api/v1/inventories/sync-data-collection-provider/');
  },
  continuousAuctionBatchLotUp(data) {
    return http.post(`/api/v1/inventories/continuous-auction-batch-lot-up/`, data);
  },
  validateGroupedItems(data) {
    return http.post(`/api/v1/inventories/validate-and-get-grouped-item/`, data);
  },
  createGroupedInventory(data, expand = '') {
    return http.post(`/api/v1/inventories/grouped-items/?expand=${expand}`, data);
  },
  updateGroupedInventory(id, data, expand) {
    return http.put(`/api/v1/inventories/grouped-items/${id}/?expand=${expand}`, data);
  },
  inventoryBulkUpdate(data) {
    return http.post(`/api/v1/inventories/bulk-edit/`, data);
  },
  createInventoryMiscCharge(inventoryUuid, data) {
    return http.post(`/api/v1/inventories/${inventoryUuid}/miscellaneous-items/`, data);
  },
  getMovementHistory(inventoryUuid, params = {}) {
    return http.get(`/api/v1/inventories/${inventoryUuid}/movement-history/`, {
      params: {
        expand: 'created_by,from_location_path,to_location_path',
        ...params,
      },
    });
  },
  updateInventoryMiscCharge(inventoryUuid, id, data) {
    return http.put(`/api/v1/inventories/${inventoryUuid}/miscellaneous-items/${id}/`, data);
  },
  removeInventoryMiscCharge(inventoryUuid, id) {
    return http.delete(`/api/v1/inventories/${inventoryUuid}/miscellaneous-items/${id}/`)
  },
  getInventorySticker(uuid) {
    return http.get(AppSettings.getUrl(`/api/v1/inventories/${uuid}/sticker/`));
  },
  createReturnNotes(data, expand = '') {
    return http.post(`/api/v1/inventories/return-notes/?expand=${expand}`, data);
  },
  updateReturnNote(uuid, data) {
    return http.patch(`/api/v1/inventories/return-notes/${uuid}/`, data);
  },
  exportInventoryOverview(data) {
    return http.post(`/api/v1/inventories/export-inventory-overview/`, data);
  },
  bulkRelocate(data) {
    return http.post(`/api/v1/inventories/bulk-relocate/`, data);
  },
  updateInventoryTerms(payload) {
    return http.patch(`/api/v1/inventories/partial/${payload.uuid}/`, payload.data)
  },
  transferAcrossBranches(data) {
    return http.post(`/api/v1/inventories/transfer-across-branches/`, data);
  },
  batchUpdateReceipt(data) {
    return http.post(`/api/v1/inventories/batch-update-receipt/`, data);
  },
  getQrCodeForWebapp(params) {
    return http.post('/api/v1/inventories/qr-code-for-webapp-pdf/', params);
  },
  requestTranslations(data) {
    return http.post(`/api/v1/inventories/translations/request-translations/`, data);
  },
  validateBulkEditTemplate(params = {}) {
    return http.post('/api/v1/inventories/bulk-edit-template/', {
      validation: true,
      receipt_uuids: params.receipt_uuids || [],
      auction_uuids: params.auction_uuids || []
    });
  },
  downloadBulkEditTemplate(params = {}) {
    return http.post('/api/v1/inventories/bulk-edit-template/', {
      template_type: params.template_type || 'empty',
      receipt_uuids: params.receipt_uuids || [],
      auction_uuids: params.auction_uuids || []
    });
  },
  uploadBulkEditTemplate(data) {
    return http.post('/api/v1/inventories/bulk-edit-upload/', data, {
      headers: {'Content-Type': 'multipart/form-data'}
    });
  },

  batchDownloadImages({inventory_uuids, file_name_template}) {
    return http.post('/api/v1/inventories/batch-download-images/', {inventory_uuids, file_name_template});
  },
  generateAiImages(inventoryUuid, imageUuids, extraPrompt = '', count = 2, referenceImageData = null) {
    const payload = {image_uuids: imageUuids, extra_prompt: extraPrompt, count}
    if (referenceImageData) payload.reference_image_data = referenceImageData
    return http.post(`/api/v1/inventories/${inventoryUuid}/ai-generate-images/`, payload)
  },

  confirmAiImages(inventoryUuid, images) {
    return http.post(`/api/v1/inventories/${inventoryUuid}/ai-confirm-images/`, {images})
  },

  async warnOnCollectionForDynamicFields(vm, items, isForm = true) {
    const masterLang = i18nHelper.getMasterLanguage()

    let mainWarningArr = []

    let response = await DepartmentService.getDepartments({
      uuids: items.map(item => item.department.uuid).join(','),
      expand: 'dynamic_fields_template'
    })
    if (!response.success) {
      return false
    }

    let departmentMap = {}
    for (let dept of response.body) {
      departmentMap[dept.uuid] = dept;
    }

    for (let item of items) {
      let labelsToWarn = []
      if (item.department && departmentMap[item.department.uuid]) {
        let dfTemplate = departmentMap[item.department.uuid].dynamic_fields_template
        for (let key in dfTemplate) {
          if (dfTemplate[key].warning_on_collection) {
            if (isForm && item[`${key}_${masterLang.key}`]) {
              labelsToWarn.push(dfTemplate[key].label)
            } else if (!isForm && item.dynamic_fields[masterLang.key][key]) {
              labelsToWarn.push(dfTemplate[key].label)
            }
          }
        }

        if (labelsToWarn.length > 0) {
          mainWarningArr.push(`${item.stock_no} - ${labelsToWarn.join(', ')}`)
        }
      }
    }

    if (mainWarningArr.length > 0) {
      let errTxt = []
      errTxt.push(vm.$createElement('p', {class: "mb-0"}, vm.$i18n.t('Please note following checkboxes have been selected for these items')))
      errTxt.push(vm.$createElement('ul', {class: "mb-0"}, mainWarningArr.map(txt => vm.$createElement('li', {}, txt))));

      let el = vm.$createElement('div', {}, errTxt)
      const tmp = new vm.$root.constructor({render: h => el}).$mount(); // creates tmp.$el
      const html = tmp.$el.outerHTML;  // <-- extracted HTML string
      tmp.$destroy();

      return await vm.$confirm(html)
    }

    return true
  }
};
